import { render } from "./SideBar.vue?vue&type=template&id=27b7366e"
const script = {}

import exportComponent from "D:\\xurshid\\PROJECTS\\fvvga\\sayt\\vue_asosiy\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__